const port = window.location.port === '3001' 
  ? process.env.REACT_APP_DEV_PORT 
  : process.env.REACT_APP_FALLBACK_PORT;


  console.log(process.env.REACT_APP_LOGO_VISIBILITY, "Logo Visiblility")


module.exports = {
  api: {
    API_URL: process.env.REACT_APP_PRD_API_URL.replace('PORT', port),
    API_URL_LOCAL_HOST: process.env.REACT_APP_DEV_API_URL.replace('PORT', port),
    tiny_mce_api_key:"dvc9zl9d5ip1dqewljzsvs38bv52i4zb411b5gt3r1pzqbqu"
  },
  general_config: {
    PER_PAGE_CONTENT: parseInt(process.env.REACT_APP_PER_PAGE_CONTENT, 10),
    chat_limit: parseInt(process.env.REACT_APP_CHAT_LIMIT, 10),
    max_records: parseInt(process.env.REACT_APP_MAX_RECORDS, 10),
    bot_allow_see_source: process.env.REACT_APP_BOT_ALLOW_SEE_SOURCE === 'true',
    chat_file_upload_limit: parseInt(process.env.REACT_APP_CHAT_FILE_UPLOAD_LIMIT, 10),
    reCAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    Max_Token_Allowed: parseInt(process.env.REACT_APP_MAX_TOKEN_ALLOWED, 10),
    group_token_usage_default_month: parseInt(process.env.REACT_APP_GROUP_TOKEN_USAGE_DEFAULT_MONTH, 10),
    LOGO_VISIBILITY:process.env.REACT_APP_LOGO_VISIBILITY === 'true'
  },

  tool_tip:{
    send_button:"Send Message",
    temp_para_one:"Controls the creativity of the bot's responses. Lower values (e.g., 0 or 0.1)make responses more predictable, while higher values (e.g., 0.7 or 1.0) result in more varied and creative replies.",
    top_p:"Controls the randomness of responses by limiting the selection to the smallest set of words whose cumulative probability meets the specified threshold. Higher values (e.g., 0.9) allow more diverse outputs, while lower values (e.g., 0.5) make responses more focused and deterministic.",
    vectordbchunkcount:"In a vector database, chunk size specifies how many vectors are processed, stored, or retrieved together in a single operation. It impacts performance, memory usage, and efficiency during indexing, storage, and querying. Smaller chunk sizes reduce memory usage but can increase the number of operations, while larger chunk sizes improve throughput but require more memory. The optimal chunk size typically ranges from 1000 to 5000 vectors, depending on the dataset size, system resources, and query patterns. For small-scale deployments, smaller chunks (100–1000) work well, while larger-scale systems benefit from bigger chunks (5000+). Adjusting chunk size is key to system optimization.",
    vectorsearchscorethreshold:"Lorem ipsome is a dummy text",
    max_record:'Sets the maximum number of results or responses the bot can generate or retrieve at once from Database.',
    bot_type:'DBinsight.ai supports two types of bots to help you access and analyze data:',
    general_bot:'',
    general_bot_one:"- Use this bot to add knowledge from documents, websites, or Q&A",
    general_bot_two:"- It can also retrieve information from the internet using advanced AI models.",
    db_bot:"",
    db_bot_one:"- Use this bot to access and query your connected databases.",
    db_bot_two:"- It can also switch to internet inquiry mode for broader searches.",
    prompt_category:"You may create different categories to organize your prompt.",
    sql_query:'SQL (Structured Query Language) communicates with a database to retrieve, update, insert, or delete data. SQL queries are used to interact with relational databases, allowing users to manage and manipulate structured data efficiently.',
    allow_users_to_run_prompt:'If select yes, both Bot Users and Bot Viewers can resend the inquiry to the LLM for processing. Note that this will incur additional token usage.',
    allow_users_to_run_sql:'both Bot Users and Bot Viewers can request results directly from the SQL program. No additional tokens will be consumed.',
    heart_icon:"Mark this prompt as “Favourite Prompt” and share with other Bot Users and Bot Viewers.",
    globe_icon:"Retrieve information from the internet",
    language_icon:"Enforces the content results to be generated in a specific language.",
    mic_icon:"Tap to use the microphone and ask your questions verbally.",
    createnewbot:"Create New Bot",
    createnewthread:"Create New Thread",
    export_table_csv: "Download this table as CSV",
    insert_table_csv: "Insert",
    clear:"Clear Context",
    information_chat_input:"Message to be passed as input.",
    create_Dashboard_Element: "Create A Dashboard Element",
    Phython_Editor:"Open Python Code Editor",

  },
  google_api_key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};
